import { useEffect, useState } from "react";
import axios from "axios";

const useFetch = (url) => {

  url="https://dummy-app-link.herokuapp.com/api"+url
  // url="http://localhost:8000/api"+url

  console.log("reFetch===>", url);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(url);
        setData(res.data);
        console.log("res.data=>", res.data);
      } catch (err) {
        setError(err);
      }
      setLoading(false);
    };
    fetchData();
  }, [url]);

  const reFetch = async () => {
    // console.log("reFetch===>",data);
    setLoading(true);
    try {
      const res = await axios.get(url);
      setData(res.data);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  return { data, loading, error, reFetch };
};

export default useFetch;
